<template>
  <Card>
    <Spin fix v-if='loading'></Spin>
    <div>
      <Divider orientation="left">本人</Divider>
      <!-- 下载调档函 -->
      <template v-if="tableData.personFileVerificationType==$store.state.fileVerificationInfoType.居住证积分档案单位">
        <Alert type="error" v-if="tableData.ddhGuid==null">调档函正在生成中，请大约过30分钟后再来下载。</Alert>
        <Button type="primary" @click="downDDH(1)" :disabled="(!tableData.isAllowDown_本人调档函)||(tableData.ddhGuid==null)" :loading="loadingBR">下载本人调档函</Button>
        <span class="tipsC">已下载次数(最多可下载3次)：{{tableData.ddhDownloadCount}}次</span>
      </template>
      <!-- 中心，无需下载 -->
      <template v-if="tableData.personFileVerificationType==$store.state.fileVerificationInfoType.档案在人才中心">
        <div class="error_Color" v-if="tableData.personArchiveManageNotInTalentCenter">
          <Icon type="md-information-circle" color="#ff2c00" size="16" /> 档案保管单位与实际档案保管单位不一致
        </div>
        <Alert type="success">档案已在浦东新区人才服务中心，无需下载调档函</Alert>
      </template>
      <!-- 无需核档 -->
      <template v-if="tableData.personFileVerificationType==$store.state.fileVerificationInfoType.无需核档">
        <Alert type="success">无需核档</Alert>
      </template>
      <table class="info-table">
        <tr>
          <td class="title-cell">核档类型</td>
          <td>{{ tableData.personFileVerificationTypeText }}</td>
        </tr>
        <tr>
          <td class="title-cell">姓名</td>
          <td>{{ tableData.name }}</td>
        </tr>
        <tr>
          <td>身份证号</td>
          <td>{{ tableData.idNo }}</td>
        </tr>

        <tr>
          <td>公司名称</td>
          <td>{{ tableData.enterpriseName }}</td>
        </tr>
        <tr>
          <td>手机号</td>
          <td>{{ tableData.phone }}</td>
        </tr>
        <tr>
          <td>原档案保管机构</td>
          <td>{{ tableData.archiveStorageUnit }}</td>
        </tr>
        <tr>
          <td>配偶随调/随迁</td>
          <td>{{ tableData.spouseIsSDSQText }}</td>
        </tr>
      </table>

      <!-- 上传核档表 -->
      <template v-if="tableData.personFileVerificationType==$store.state.fileVerificationInfoType.落户档案在单位">
        <Button type="primary" style="margin-top:10px;" @click="uploadHDB(1)">上传核档表</Button>
        <div class="_linkdel" v-if="tableData.personHDBGuid">
          <div class="fileCentent" @click="handlePreview(tableData.personHDBGuid)">
            <Icon :type="'核档表' | fileType" />
            核档表
          </div>
          <!-- <div class="fileDel">
            <Icon type="md-close" @click="handleRemove(file, null, 'personnelLetterGuid')" />
          </div> -->
        </div>
      </template>
    </div>
    <div v-if="tableData.isShow_配偶信息">
      <Divider orientation="left">配偶</Divider>
      <!-- 下载调档函 -->
      <template v-if="tableData.spouseFileVerificationType==$store.state.fileVerificationInfoType.居住证积分档案单位">
        <Alert v-if="tableData.spouseDDHGuid==null" type="error">调档函正在生成中，请大约过30分钟后再来下载。</Alert>
        <Button type="primary" :loading="loadingPO" @click="downDDH(5)" :disabled="(!tableData.isAllowDown_配偶调档函)||(tableData.spouseDDHGuid==null)">下载配偶调档函</Button>
        <span class="tipsC">已下载次数(最多可下载3次)：{{tableData.spouseDDHDownloadCount}}次</span>
      </template>
      <!-- 中心，无需下载  -->
      <template v-if="tableData.spouseFileVerificationType==$store.state.fileVerificationInfoType.档案在人才中心">
        <div class="error_Color" v-if="tableData.spouseArchiveManageNotInTalentCenter">
          <Icon type="md-information-circle" color="#ff2c00" size="16" /> 档案保管单位与实际档案保管单位不一致
        </div>
        <Alert type="success">档案已在浦东新区人才服务中心，无需下载调档函</Alert>
      </template>
      <!-- 无需核档 -->
      <template v-if="tableData.spouseFileVerificationType==$store.state.fileVerificationInfoType.无需核档">
        <Alert type="success">无需核档</Alert>
      </template>
      <table class="info-table">
        <tr>
          <td class="title-cell">核档类型</td>
          <td>{{ tableData.spouseFileVerificationTypeText }}</td>
        </tr>
        <tr>
          <td class="title-cell">姓名</td>
          <td>{{ tableData.spouseName }}</td>
        </tr>
        <tr>
          <td>身份证号</td>
          <td>{{ tableData.spouseIdNo }}</td>
        </tr>
        <tr>
          <td>公司名称</td>
          <td>{{ tableData.spouseEnterpriseName }}</td>
        </tr>
        <tr>
          <td>原档案保管机构</td>
          <td>{{ tableData.spouseArchiveStorageUnit }}</td>
        </tr>
      </table>

      <!-- 上传核档表 -->
      <template v-if="tableData.spouseFileVerificationType==$store.state.fileVerificationInfoType.落户档案在单位">
        <Button type="primary" style="margin-top:10px;" @click="uploadHDB(5)">上传核档表</Button>
        <div class="_linkdel" v-if="tableData.spouseHDBGuid">
          <div class="fileCentent" @click="handlePreview(tableData.spouseHDBGuid)">
            <Icon :type="'核档表' | fileType" />
            核档表
          </div>
          <!-- <div class="fileDel">
            <Icon type="md-close" @click="handleRemove(file, null, 'personnelLetterGuid')" />
          </div> -->
        </div>
      </template>
    </div>
    <div>
      <Modal v-model="showUploadModal" :closable="false" :mask-closable="false" title="上传核档表" @on-ok="submitHDB">
        <Form ref="hdbForm" :model="formValidate" :rules="rules">
          <FormItem prop="hdbGuid" v-if="showUploadModal" label="核档表文件">
            <Upload ref="hdbGuid" :action="$baseURL + '/common/file/uploadfile'" :format="['jpg','jpeg','png','pdf']" :max-size="5120" :on-success="uploadSuccess" :before-upload="handleBeforeUpload" :on-preview="handlePreview"
              :on-remove="() => {this.formValidate.hdbGuid = '';this.uploadFileGuid = ''}">
              <Button icon="ios-cloud-upload-outline">选择文件</Button>
            </Upload>
          </FormItem>
        </Form>
        <template #footer>
          <Button type="text" @click="showUploadModal=false">取消</Button>
          <Button type="primary" @click="submitHDB">保存</Button>
        </template>
      </Modal>
    </div>

  </Card>
</template>
<script>
export default {
  data() {
    return {
      // 表格数据
      tableData: {},
      loading: false,
      showUploadModal: false,
      loadingBR: false,
      loadingPO: false,
      uploadFileGuid: '',
      currentUploadType: 0, // 1-本人 5-配偶
      formValidate: {
        hdbGuid: '',
      },
      rules: {
        hdbGuid: [{ required: true, message: '必须上传核档表文件', trigger: 'change' }],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    handleBeforeUpload(file) {
      this.$refs['hdbGuid'].clearFiles()
      const isValidType = ['jpg', 'jpeg', 'png', 'pdf'].includes(file.type.split('/')[1])
      if (!isValidType) {
        this.$Message.error('只支持JPG/PNG/PDF格式')
        return false
      }
      return true
    },
    // 获取表格数据
    async getData() {
      this.loading = true
      try {
        let { data } = await this.$Ajax.post(
          '/api/services/app/TSRCDDHApi/GetCurrentSpecialTalentDDH'
        )
        console.log('🚀 ~ getData ~ data:', data)
        this.tableData = data.result
      } catch (error) {
        this.$Modal.error({
          title: '提示',
          content: '出错了',
        })
      }

      this.loading = false
    },
    async downDDH(type) {
      if (type == 1) {
        this.loadingBR = true
      } else {
        this.loadingPO = true
      }
      let { data } = await this.$Ajax.post('/api/services/app/TSRCDDHApi/DonwDDH', {
        guid: this.tableData.guid,
        type: type,
      })
      this.tableData.ddhDownloadCount = data.result.ddhDownloadCount
      this.tableData.spouseDDHDownloadCount = data.result.spouseDDHDownloadCount
      this.tableData.isAllowDown_本人调档函 = data.result.isAllowDown_本人调档函
      this.tableData.isAllowDown_配偶调档函 = data.result.isAllowDown_配偶调档函
      let res = await this.$downLoad(data.result.url)
      console.log('🚀 ~ downDDH ~ res:', res)

      this.loadingBR = false
      this.loadingPO = false
    },
    uploadHDB(type) {
      this.formValidate.hdbGuid = ''
      this.uploadFileGuid = ''
      this.currentUploadType = type
      this.showUploadModal = true
    },
    uploadSuccess(res) {
      try {
        if (this.$security_EncriptResponse) {
          res = this.$decryptData(res.data)
        }
      } catch {}
      this.uploadFileGuid = res.result.guid
      this.formValidate.hdbGuid = res.result.guid
    },
    handleSubmit() {
      this.$refs.hdbForm.validate((valid) => {
        if (valid) {
          this.submitHDB()
        } else {
          this.$Message.error('请完成必填项')
        }
      })
    },
    async submitHDB() {
      // 添加表单验证
      if (!this.uploadFileGuid) {
        this.$Message.error('请先上传核档表文件')
        return
      }
      try {
        let { data } = await this.$Ajax.post('/api/services/app/TSRCDDHApi/SubmitHDB', {
          guid: this.tableData.guid,
          type: this.currentUploadType,
          hdbGuid: this.uploadFileGuid,
        })
        this.$Message.success('上传成功')
        this.showUploadModal = false
        // this.tableData = data.result
        this.getData() // 刷新数据
      } catch (error) {
        this.$Modal.error({ title: '错误', content: '上传失败' })
      }
    },
    //查看文件
    handlePreview(file) {
      window.open('/file/preview/' + file)
    },
  },
}
</script>

<style scoped lang="less">
.info-table {
  width: 100%;
  margin-top: 10px;
  border-collapse: collapse;
}

.info-table td {
  padding: 8px;
  border: 1px solid #e8eaec;
}

.title-cell {
  width: 160px;
}
/deep/.ivu-divider-horizontal.ivu-divider-with-text-center,
.ivu-divider-horizontal.ivu-divider-with-text-left,
.ivu-divider-horizontal.ivu-divider-with-text-right {
  margin: 10px 0 !important;
}
.tipsC {
  // margin-top:5px;
  // background: #f7f7f7;
  min-height: 30px;
  line-height: 24px;
  padding: 3px 5px;
  // border: 1px solid #e2e2e2;
  border-radius: 4px;
  display: inline-block;
  vertical-align: middle;
  // margin-left: 10px;
}
.error_Color {
  color: red;
  margin: 10px 0px;
}
</style>




